var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "nav-wrapper flex justify-between align-center"
  }, [_c("a-icon", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.horizontal,
      expression: "!horizontal"
    }],
    staticClass: "nav-fold boxHover",
    attrs: {
      type: _vm.collapsed ? "menu-fold" : "menu-unfold"
    },
    on: {
      click: _vm.toggleOpen
    }
  }), _c("bread-crumb", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.horizontal,
      expression: "!horizontal"
    }]
  }), _c("div", {
    staticClass: "right-menu flex"
  }, [_c("div", {
    staticClass: "right-menu-item pointer boxHover",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.screenFull.apply(null, arguments);
      }
    }
  }, [_c("svg-icon", {
    attrs: {
      icon: _vm.isFullscreen ? "exit-fullscreen" : "fullscreen",
      size: 18
    }
  })], 1), _c("a-tooltip", {
    attrs: {
      placement: "bottom"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" 主题配置 ")]), _c("div", {
    staticClass: "right-menu-item pointer boxHover",
    on: {
      click: _vm.changeVisible
    }
  }, [_c("svg-icon", {
    attrs: {
      icon: "color",
      size: 18
    }
  })], 1)], 2), _c("nav-user", {
    staticClass: "right-menu-item pointer boxHover flex-sub"
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };